import { Injectable } from '@angular/core';
import { fromEvent, Subject, Observable } from 'rxjs';
import { isEqual } from 'lodash';
import { FocusItemDirective } from './focus-item.directive';
import { by } from 'protractor';

@Injectable({
  providedIn: 'root'
})
export class FocusManagerService {
  private changeEvent = new Subject<FocusItemDirective[]>();
  get onChange(): Observable<FocusItemDirective[]> {
    return this.changeEvent.asObservable();
  }
  /**
   * list of focus items before
   */
  private focus_item_list_old: FocusItemDirective[] = [];
  /**
   * list of focus items current
   */
  private focus_item_list_new: FocusItemDirective[] = [];
  /**
   * A click will bubble up until it reaches document.
   * This upward trip can pass multiple focus items
   * This property holds the status on whether this bubble-up is happening or not.
   */
  private bubbleUpStarted: boolean = false;

  constructor() {
    fromEvent(document, 'click').subscribe((event: MouseEvent) => {
      this.onDocumentClick(event);
    });
  }

  /**
   * record a focus item into current list of focus items.
   * if bubble-up has just started and bubbleUpStarted is yet to be updated,
   * 1. update bubbleUpStarted to true.
   * 2. move all the current focus item list into the old list
   * 3. create an empty list
   * @param item
   */
  push(item: FocusItemDirective) {
    if (this.bubbleUpStarted === false) {
      this.bubbleUpStarted = true;
      this.emptyFocusItems();
    }
    this.focus_item_list_new.push(item);
  }
  private emptyFocusItems() {
    this.focus_item_list_old = [].concat(this.focus_item_list_new);
    this.focus_item_list_new = [];
  }
  private onDocumentClick(event: MouseEvent) {
    try {
      this.bubbleUpStarted = false;
      let path = this.filterFocusItemElements(event.target as
        | HTMLElement
        | Document
        | Body);
      if (path.length === 0) this.emptyFocusItems();
      if (!isEqual(this.focus_item_list_old, this.focus_item_list_new))
        this.changeEvent.next(this.focus_item_list_new);
    } catch (e) {
      console.error(e);
    }
  }
  private filterFocusItemElements(
    element: HTMLElement | Document | Body
  ): HTMLElement[] {
    let list: HTMLElement[] = [];

    while (element !== document.body && element !== document) {
      if (!element) break;
      if ((<HTMLElement>element).hasAttribute('focus-item'))
        list.push(<HTMLElement>element);
      element = (<HTMLElement>element).parentElement;
    }
    return list;
  }
}
